export const NarvarConst = {
  returns_redesign_name: 'algo.returns_redesign.narvar',
  returns_redesign_enabled: 'enabled',
  returns_redesign_disabled: 'disabled',
};
